import { DetailedHTMLProps, SelectHTMLAttributes } from 'react';

interface SelectProps extends DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  children: React.ReactNode;
}

export default function Select({ children, ...props }: SelectProps) {
  return (
    <div className="custom-select">
      <select {...props}>{children}</select>
    </div>
  );
}
